
import { createSlice } from '@reduxjs/toolkit';
import { createexperience, DeleteExperience, fetchingexperience, Updateexperience } from './experience.Action';

export interface Experience {
  Id: number;
  Label: string;
  TimePeriod: string;
  Status: "active" | "inactive";
  CreatedAt?: string;
  CreatedBy?: number;
  ModifiedBy?: number;
}

export interface ExperienceState {
  experiences: Experience[];
  selectedExperience?: Experience;
  loading: boolean;
  error?: string;
}

const initialState: ExperienceState = {
  experiences: [],
  selectedExperience: undefined,
  loading: false,
  error: undefined,
};

const experienceSlice = createSlice({
  name: 'experience',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createexperience.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createexperience.fulfilled, (state, action) => {
        state.loading = false;
        state.experiences.push(action.payload);
      })
      .addCase(createexperience.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(fetchingexperience.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchingexperience.fulfilled, (state, action) => {
        state.loading = false;
        state.experiences = action.payload.data ?? action.payload;
      })
      .addCase(fetchingexperience.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(Updateexperience.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(Updateexperience.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload?.data ?? action.payload;

        const index = state.experiences.findIndex(
          (exp) => exp.Id === updated.Id
        );

        if (index !== -1) {
          state.experiences[index] = updated;
        }
      })
      .addCase(Updateexperience.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(DeleteExperience.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(DeleteExperience.fulfilled, (state, action) => {
        state.loading = false;
        state.experiences = state.experiences.filter(
          (exp) => exp.Id !== action.meta.arg
        );
      })
      .addCase(DeleteExperience.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default experienceSlice.reducer;
